import { PrimaryButton, SecondaryButton, Typography } from '@weareopenr/component-library';
import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { useForm } from 'react-hook-form';
import MenuItemType from 'src/components/MenuItemType/MenuItemType';
import { ItemType } from 'src/constants';
import { TMenuItemType } from 'src/types/menu.types';
import { ButtonContainer } from '../../ButtonContainer/ButtonContainer';
import { IGlobalItem, Steps } from '../types';
import styles from './GlobalItemTypeForm.module.scss';
import { FormVariant } from 'src/types/menuItemForm.types';

const titleMap = new Map<FormVariant, string>([
  [FormVariant.CREATE, 'Product Type'],
  [FormVariant.UPDATE, 'Edit Product Type'],
]);

const subtitleMap = new Map<FormVariant, string>([
  [FormVariant.CREATE, 'Select the type of item you wish to create'],
  [FormVariant.UPDATE, 'Update the product type'],
]);

interface IGlobalItemTypeFormProps {
  variant: FormVariant;
  setStep?: Dispatch<SetStateAction<Steps>>;
  setGlobalItem?: Dispatch<SetStateAction<Partial<IGlobalItem>>>;
  onCancel: () => void;
  onSubmitItem?: (data: Partial<IGlobalItem>, isDirty: boolean) => void | undefined;
  defaultType: TMenuItemType | undefined;
  item?: Partial<IGlobalItem>;
  isSubmitting?: boolean;
}

export const GlobalItemTypeForm = ({
  variant,
  setStep,
  setGlobalItem,
  onCancel,
  defaultType,
  onSubmitItem,
  isSubmitting,
  item,
}: IGlobalItemTypeFormProps) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty },
  } = useForm<Partial<IGlobalItem>>({
    defaultValues: { type: defaultType || ItemType.STANDARD },
  });

  const onSubmit = (data: Partial<IGlobalItem>) => {
    if (onSubmitItem) {
      onSubmitItem({ ...item, ...data }, isDirty);
    } else {
      if (data.type === ItemType.BUNDLE) {
        setGlobalItem({ ...data, recipe_id: null });
      } else {
        setGlobalItem({ ...data });
      }
      setStep(Steps.details);
    }
  };

  const handleOnChange = (event: ChangeEvent<HTMLFormElement>) => {
    setGlobalItem({ ...item, type: event.target.value });
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['title-container']}>
        <Typography weight="semi-bold" size="xxlarge">
          {titleMap.get(variant)}
        </Typography>
        <Typography>{subtitleMap.get(variant)}</Typography>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} onChange={handleOnChange}>
        <MenuItemType onEdit={!!onSubmitItem} control={control} />
        <ButtonContainer
          left={
            <SecondaryButton size="full-width" type="button" buttonStyle="outline" onClick={() => onCancel()}>
              Cancel
            </SecondaryButton>
          }
          right={
            <PrimaryButton type="submit" size="full-width" loading={isSubmitting}>
              {onSubmitItem ? `Save` : `Continue`}
            </PrimaryButton>
          }
        />
      </form>
    </div>
  );
};
